<template>
  <div id="app" >
     <div>
         <div class="header">

        <div class="logo">
        <img src="./assets/toplogo.png" alt />
      </div>
      <el-menu
        id="navs"
        :default-active="$route.path"
        mode="horizontal"
        @select="handleSelect"
        :router="router"
        text-color="#1A1A1A"
        active-text-color="#0090E3">
        <el-menu-item  index="/">公司简介</el-menu-item>
        <el-menu-item  index="/culture">企业文化</el-menu-item>
        <el-menu-item  index="/welfare"><template><div style="width:100%;height:100%;" @mouseenter="mouseenter()" @mouseleave="mouseleave()"><span>员工福利</span></div></template></el-menu-item>
        <el-menu-item  index="/advance">学习发展</el-menu-item>
         <!-- <el-submenu index="/applyProcess" >
           <template slot="title">加入我们</template>
           <el-menu-item index="/applyProcess">应聘流程</el-menu-item>
           <el-menu-item index="/positions">职位速递</el-menu-item>
        </el-submenu> -->
        <el-menu-item index="/applyProcess">应聘流程</el-menu-item>
        <el-menu-item style="margin-right:0px" index="/contactUs">联系我们</el-menu-item>
      </el-menu>
    </div>
      </div>

    <div class="content"  @scroll="scrollEvent" ref="scrollDiv"><router-view :byScroll ="byScroll" :selecetdMenu = "selecetdMenu" />
    <div class="footer">
    <img class = "footlogo" src="./assets/footlogo.png" alt />

    <div style="text-align: left;width:max-content;float: left;margin-left: 25%;margin-top: 53px;display: flex;flex-flow: row;flex-wrap: nowrap;justify-content: flex-start;" >
      <img src="./assets/icon_contact.png" alt style="width:46px;height:46px vertical-align: middle; "/>
      <span style="font-size:14px;color: #FFFFFF;display: inline-block;margin-left: 34px;">联系方式：<br/><font style="color: #AAAAAA;">business@yongxintechhk.com</font></span>
    </div>

    <div style="text-align: left;width:max-content;float: left;margin-left: 25%;margin-top: 41px;display: flex;flex-flow: row;flex-wrap: nowrap;justify-content: flex-start;" >
      <img src="./assets/icon_position.png" alt style="width:46px;height:46px"/>
      <span style="font-size:14px;color: #FFFFFF;display: inline-block;margin-left: 34px;">联系地址：<br/><font style="color: #AAAAAA;">S8 9F W LUXE 5 ON YIU STREET SHA TIN NT HK</font></span>
    </div>
    </div>
    </div>

    <div id="menu"  v-show="showMenu" @mouseenter="mouseenter()" @mouseleave="mouseleave()">
      <button v-for="(item,index) in menu" :key="index" v-on:click="clickMenuItem(index)" :style="{color:(selecetdMenu==index)?'#0090E3':'#1A1A1A',fontWeight:(selecetdMenu==index)?'bold':'normal'}">{{item}}</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userClick:false,
      router: true,
      showMenu:false,
      selecetdMenu:0,
      menuLeft:838,
      byScroll:false,
      lastkey:'/',
      menu:[ '薪资结构','动力保障','缤纷生活','家属福利'],
    };
  },

  mounted () {
      this.calulatePosition();
  },
  methods: {
    handleSelect(key, keyPath) {
      if(this.lastkey!=key){
        this.lastkey = key;
        this.$refs.scrollDiv.scrollTo(0, 0)
      }
       if('/welfare'===key){
          if(this.showMenu){
            this.showMenu = false
          }else{
             this.showMenu = true
          }
          this.calulatePosition();
      }else{
         this.showMenu = false
      }

    },
    clickMenuItem(index){
      this.byScroll = false;
      this.selecetdMenu = index;
      this.showMenu = false;
      this.$router.push({name:'Welfare',params:{selecetdMenu:this.selecetdMenu}});
    },
    mouseenter(){
      this.showMenu = true;
    },
    mouseleave(){
       this.showMenu = false;
    },
    calulatePosition() {
      let navs = document.getElementById("navs");
      let target = navs.children[2];
      if(target!=null ){
       console.log("menu,"+navs.offsetLeft+":::"+target.offsetLeft+":::"+target.style.left);
       this.menuLeft =  navs.offsetLeft+target.offsetLeft
      }else{
        this.menuLeft = 838
      }
      let menu = document.getElementById("menu");
      if(menu!=null){
       menu.style.left = this.menuLeft+'px';
      }
    },
     // 获取页面滚动距离
	    scrollEvent () {
        this.showMenu = false;
        let scrollHeight = this.$refs.scrollDiv.scrollTop;
        console.log("滑动距离"+scrollHeight);
        this.byScroll = true;
        if(scrollHeight>=2574){
            this.selecetdMenu = 3;
        }else if(scrollHeight>=1484){
            this.selecetdMenu = 2;
        }else if(scrollHeight>=806){
            this.selecetdMenu = 1;
        }else{
            this.selecetdMenu = 0;
        }
      },

  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
  height: 100%;
}
.content{
   height: calc(100% - 7rem);
   overflow:scroll;
   position: relative;
}
.header{
  height: 7rem;
  display:inline-flex;
	flex-flow: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
  width:fit-content;
}
.footer{
  width: 100%;
  height: 15rem;
  background-color: #1a1a1a;
}
.footlogo{
  width:130px;
  height:125px;
  float: right;
  margin-right: 25%;
  margin-top: 57px;
}
/* .el-menu {
  margin-left: 160px;
} */
#navs {
    background-color:#fff;
}

#navs /deep/ .el-menu-item {
    font-size: 18px;
    height: 112px;
    line-height: 112px;
    margin: 0;
    color: #1A1A1A;
    font-weight: normal;
    padding-left: 19px;
    padding-right: 19px;
    margin-left: 19px;
    margin-right: 19px;
    background-color: #fff;
}
.el_menu_item_last{
    margin-right: 0px;
}
#navs /deep/ .el-submenu {
    margin-left: 19px;
    margin-right: 19px;
}

/* #navs /deep/ .el-menu--popup-bottom-start.el-menu-item{
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 1rem;
} */
.el-menu--horizontal>.el-menu--popup-bottom-start>.el-menu-item{
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 1rem;
}
.el-menu--horizontal>.el-menu--popup-bottom-start>.el-menu-item:hover{
  font-weight: bold;
}
.el-menu--horizontal>.el-menu--popup-bottom-start>.el-menu-item.is-active{
  font-weight: bold;
}
.el-menu--horizontal /deep/ .el-submenu__title{
    font-size: 18px;
    height: 112px;
    line-height: 112px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #1A1A1A;
    font-weight: normal;
}

#navs /deep/ .el-submenu__title.is-active{
  font-weight: bold;
  color: #0090E3;
}
#navs /deep/  .el-submenu__title:hover{
  font-weight: bold;
  color: #0090E3;
  background-color: #e6e6e6 !important;
}

#navs /deep/ .el-menu-item.is-active {
  font-weight: bold;
  color: #0090E3;
  border-bottom: 2px solid #0090E3;
}

        /*  */
#navs /deep/ .el-menu-item:hover {
  font-weight: bold;
  color: #0090E3;
  background-color: #e6e6e6 !important;
}

.logo{
  width:fit-content;
  margin-top: 1.4375rem;
  margin-right: 7.75rem;
}

img {
  width: 70px;
  line-height: 66px;
}
#menu{
background-color: #fff;
width:10.25rem;
height:fit-content;
position: absolute;
top: 112px;
overflow:visible;
z-index: 999;
padding-top: .9375rem;
padding-bottom:.9375rem;
-webkit-box-shadow:3px 3px 3px 3px rgba(0,0,0,0.21);
-moz-box-shadow:3px 3px 3px 3px rgba(0,0,0,0.21);
box-shadow:3px 3px 3px 3px rgba(0,0,0,0.21);
}
#menu button{
  width: 100%;
  display: inline-block;
  text-align: left;
  padding-left: 1.1875rem;
  padding-top: .9375rem;
  padding-bottom: .9375rem;
  color: #1A1A1A;
  font-size: 1rem;
  font-weight: normal;
  background: none;
  border-block-width: 0px;
  border-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue